<template>
  <div class="site__body">
      <div class="block-space block-space--layout--after-header"></div>
      <div class="block">
          <div class="container container--max--xl">
              <div class="row">
                  <account-navigation></account-navigation>
                  <edit-address></edit-address>
              </div>
          </div>
      </div>
      <div class="block-space block-space--layout--before-footer"></div>
  </div>
</template>

<script>

import AccountNavigation from "../accountnavigation/AccountNavigation";
import EditAddress from './EditAddress';

export default {
  name: 'AccountEditAddress',
  components: {
    "account-navigation": AccountNavigation,
    "edit-address": EditAddress
  },
}

</script>